module.exports = __webpack_public_path__ + "img/angle_330.fcd565ae.jpg";